import { render } from "./ApartmentInfo.vue?vue&type=template&id=c2510e60&scoped=true"
import script from "./ApartmentInfo.vue?vue&type=script&lang=js"
export * from "./ApartmentInfo.vue?vue&type=script&lang=js"

import "./ApartmentInfo.vue?vue&type=style&index=0&id=c2510e60&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2510e60"]])

export default __exports__